
export default {

    setList(state, list) {
        state.list = list;
    },
    setPage(state, page) {
        state.page = page;
    },
}